var _style, _circle, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#0052B4;}\n\t.st4{fill:#6DA544;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,255.3H234.5c-55.1,55.1-88.4,97.6-122.4,131.7l144.7,13l224.5-22.3C500.9,341.5,512,300,512,256 C512,255.8,512,255.5,512,255.3L512,255.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112,132.8h368.4C436.9,53.7,352.7,0,256,0C185.5,0,121.7,28.5,75.4,74.6L112,132.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.2,377.7c-23,23-31.9,42.3-48.6,58.9C121,483.2,185.1,512,256,512c97.3,0,182-54.3,225.3-134.3L123.2,377.7 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75,74.2c-100,100-100,262.1,0,362c41.3-41.3,81-81,181-181L75,74.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.5,255.3c0-37.3,26.2-68.5,61.2-76.1c-5.4-1.2-11-1.8-16.7-1.8c-43,0-77.9,34.9-77.9,77.9 S69,333.2,112,333.2c5.7,0,11.3-0.6,16.7-1.8C93.7,323.7,67.5,292.6,67.5,255.3L67.5,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,188.5l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.8-7.9h13.4L127.9,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,221.9l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.8-7.9h13.4L127.9,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,255.3L132,268h13.4l-10.9,7.9l4.1,12.8l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.8-7.9h13.4L127.9,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.9,288.6l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.8-7.9L117,322l4.1-12.8l-10.8-7.9h13.4L127.9,288.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.b76a36c45510ddc69a2e008a75ed1699.svg";
export { ForwardRef as ReactComponent };